export const parseDeliveryDateValue = (rawDate) => {
  if (!rawDate || typeof rawDate !== "string") return null;

  const trimmed = rawDate.trim();
  if (!trimmed) return null;

  const ddmmyyyyMatch = trimmed.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
  if (ddmmyyyyMatch) {
    const day = Number(ddmmyyyyMatch[1]);
    const month = Number(ddmmyyyyMatch[2]) - 1;
    const year = Number(ddmmyyyyMatch[3]);
    const parsed = new Date(year, month, day);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const parsed = new Date(trimmed);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const getEditModeDeliveryDate = (savedDeliveryDate) => {
  const parsedSavedDate = parseDeliveryDateValue(savedDeliveryDate);
  if (!parsedSavedDate) return "";

  parsedSavedDate.setHours(0, 0, 0, 0);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const effectiveDate = parsedSavedDate < today ? today : parsedSavedDate;
  return effectiveDate.toString().split(" GMT")[0];
};
